module.exports = __webpack_public_path__ + "static/img/third4.816952c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/third4.png
// module id = WoMX
// module chunks = 25